export default __webpack_public_path__ + "static/media/btn-start-off.59e4743b.png";